import {
  BARCODE_FAILURE,
  BARCODE_SUCCESS,
  IMAGES_FAILURE,
  IMAGES_LOADING,
  IMAGES_SUCCESS,
} from './constants';
import { createReducer } from './utils';
import { createAbort, clearAbort, ABORT_KEYS } from './utils/abortManager';

const defaultState = {
  loading: false,
  images: [],
  barcode: '',
  errorMessage: null,
};

// reducer

export const reducer = createReducer(defaultState, {
  [IMAGES_LOADING]: handleImagesLoading,
  [IMAGES_SUCCESS]: handleImagesSuccess,
  [IMAGES_FAILURE]: handleImagesFailure,
  [BARCODE_SUCCESS]: handleBarcodeSuccess,
  [BARCODE_FAILURE]: handleBarcodeFailure,
});

function handleImagesLoading(state, action) {
  return {
    ...state,
    loading: true,
    images: [],
  };
}

function handleImagesSuccess(state, { payload: { response } }) {
  return {
    ...state,
    loading: false,
    images: response,
  };
}

function handleImagesFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    images: [],
    errorMessage: error,
  };
}

function handleBarcodeSuccess(state, { payload: { response } }) {
  return {
    ...state,
    loading: false,
    barcode: response,
  };
}

function handleBarcodeFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    barcode: '',
    errorMessage: error,
  };
}

// actions

export function getImages(task_id, task_type) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: IMAGES_LOADING });

    const {
      stores: { currentStore },
    } = getState();

    const signal = createAbort(ABORT_KEYS.TASK_IMAGES);

    try {
      let response = await dataSource.requestImages(
        { store: currentStore, task_id: task_id, task_type: task_type },
        signal,
      );
      clearAbort(ABORT_KEYS.TASK_IMAGES);
      response = response.filter(item => {
        if (typeof item === 'object') {
          if (item.url || item.metadata?.encoded_image) {
            return item;
          }
        } else {
          return item;
        }
      });
      dispatch({ type: IMAGES_SUCCESS, payload: { response } });
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.log('getImages error', error);
      dispatch({
        type: IMAGES_FAILURE,
        payload: { error },
      });
    }
  };
}

export function getBarcode(barcode, signal) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: IMAGES_LOADING });

    const {
      stores: { currentStore },
    } = getState();

    const abortSignal = signal ?? createAbort(ABORT_KEYS.PRODUCT_BARCODE);

    try {
      let response = await dataSource.requestBarcode({
        store: currentStore,
        barcode: barcode,
        signal: abortSignal,
      });
      response = response[0]['url'];

      dispatch({ type: BARCODE_SUCCESS, payload: { response } });
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.log('getBarcode error', error);
      dispatch({
        type: BARCODE_FAILURE,
        payload: { error },
      });
    }
  };
}
